(() => {

  'use strict';



  /*

   * ==========================================================

   * TOONFETTI — SAFE GLOBAL THEME JAVASCRIPT

   * ==========================================================

   *

   * NAVIGATION RULE:

   * - Do not intercept normal page links.

   * - Do not add page fades, overlays, delays, or AJAX routing.

   * - Let Shopify + the browser handle normal navigation.

   *

   * CART RULE:

   * - Do not call /cart/add.js.

   * - Do not prevent native product form submission.

   * - Shopify's native product form remains the only cart-add system.

   */



  /* ==========================================================

     HELPERS

     ========================================================== */



  const qs = (selector, root = document) =>

    root.querySelector(selector);



  const qsa = (selector, root = document) =>

    Array.from(root.querySelectorAll(selector));



  function shopRoot() {

    if (

      window.Shopify &&

      Shopify.routes &&

      Shopify.routes.root

    ) {

      return Shopify.routes.root;

    }



    return '/';

  }



  /* ==========================================================

     ADD-TO-CART MICRO CELEBRATION

     ========================================================== */



  const TF_ADD_CELEBRATION_KEY =

    'toonfetti_pending_native_add';



  function getProductData(submitter) {

    if (!submitter) {

      return null;

    }



    const card =

      submitter.closest('[data-tf-universal-card]');



    const titleElement =

      card

        ? card.querySelector('.tf-universal-title')

        : null;



    const title =

      (

        submitter.dataset.tfProductTitle ||

        (

          card

            ? card.dataset.tfProductTitle

            : ''

        ) ||

        (

          titleElement

            ? titleElement.textContent

            : ''

        ) ||

        'Your ToonFetti pick'

      )

      .replace(/\s+/g, ' ')

      .trim();



    const characterSrc =

      (

        card

          ? card.dataset.tfYellowCharacterSrc

          : ''

      ) || '';



    return {

      title,

      characterSrc

    };

  }



  function rememberNativeAdd(form, submitter) {

    if (!form || !submitter) {

      return;

    }



    if (

      !submitter.matches(

        '[data-tf-native-add], .tf-universal-add'

      )

    ) {

      return;

    }



    const data =

      getProductData(submitter);



    if (!data) {

      return;

    }



    try {

      window.sessionStorage.setItem(

        TF_ADD_CELEBRATION_KEY,

        JSON.stringify({

          title: data.title,

          characterSrc: data.characterSrc,

          time: Date.now()

        })

      );

    } catch (error) {

      /* Storage may be unavailable in strict privacy modes. */

    }

  }



  document.addEventListener(

    'submit',

    function (event) {

      const form =

        event.target instanceof HTMLFormElement

          ? event.target

          : null;



      if (!form) {

        return;

      }



      const action =

        (

          form.getAttribute('action') ||

          ''

        ).toLowerCase();



      if (

        action &&

        action.indexOf('/cart/add') === -1

      ) {

        return;

      }



      const submitter =

        event.submitter ||

        document.activeElement;



      if (!(submitter instanceof Element)) {

        return;

      }



      rememberNativeAdd(

        form,

        submitter

      );



      /*

       * Intentionally no preventDefault().

       * Shopify's native product form continues normally.

       */

    },

    true

  );



  function consumePendingNativeAdd() {

    let data = null;



    try {

      const raw =

        window.sessionStorage.getItem(

          TF_ADD_CELEBRATION_KEY

        );



      if (!raw) {

        return null;

      }



      data =

        JSON.parse(raw);



      window.sessionStorage.removeItem(

        TF_ADD_CELEBRATION_KEY

      );

    } catch (error) {

      return null;

    }



    if (

      !data ||

      !data.time ||

      (

        Date.now() -

        Number(data.time)

      ) > 15000

    ) {

      return null;

    }



    return data;

  }



  function removeAddCelebration() {

    const existing =

      qs('[data-tf-add-celebration]');



    if (existing) {

      existing.remove();

    }

  }



  function showAddCelebration(data) {

    if (!data) {

      return;

    }



    removeAddCelebration();



    const celebration =

      document.createElement('div');



    celebration.className =

      'tf-add-celebration';



    celebration.setAttribute(

      'data-tf-add-celebration',

      ''

    );



    celebration.setAttribute(

      'role',

      'status'

    );



    celebration.setAttribute(

      'aria-live',

      'polite'

    );



    if (data.characterSrc) {

      const character =

        document.createElement('div');



      character.className =

        'tf-add-celebration__character';



      character.setAttribute(

        'aria-hidden',

        'true'

      );



      const image =

        document.createElement('img');



      image.src =

        data.characterSrc;



      image.alt =

        '';



      image.width =

        58;



      image.height =

        40;



      image.setAttribute(

        'aria-hidden',

        'true'

      );



      character.appendChild(

        image

      );



      celebration.appendChild(

        character

      );

    }



    const copy =

      document.createElement('div');



    copy.className =

      'tf-add-celebration__copy';



    const eyebrow =

      document.createElement('span');



    eyebrow.className =

      'tf-add-celebration__eyebrow';



    eyebrow.textContent =

      'TOONFETTI BAG';



    const heading =

      document.createElement('strong');



    heading.textContent =

      'Added to your bag ✓';



    const product =

      document.createElement('small');



    product.textContent =

      data.title ||

      'Your ToonFetti pick';



    copy.appendChild(

      eyebrow

    );



    copy.appendChild(

      heading

    );



    copy.appendChild(

      product

    );



    celebration.appendChild(

      copy

    );



    document.body.appendChild(

      celebration

    );



    requestAnimationFrame(

      function () {

        celebration.classList.add(

          'is-visible'

        );

      }

    );



    window.setTimeout(

      function () {

        celebration.classList.remove(

          'is-visible'

        );



        window.setTimeout(

          removeAddCelebration,

          260

        );

      },

      1500

    );

  }



  function initializeAddCelebration() {

    const normalizedPath =

      window.location.pathname

        .replace(/\/+$/, '')

        .toLowerCase();



    const rootPath =

      shopRoot()

        .replace(/\/+$/, '')

        .toLowerCase();



    const cartPath =

      (

        rootPath +

        '/cart'

      )

      .replace(/\/+/g, '/');



    if (

      normalizedPath !== cartPath &&

      normalizedPath !== '/cart'

    ) {

      return;

    }



    const pending =

      consumePendingNativeAdd();



    if (pending) {

      showAddCelebration(

        pending

      );

    }

  }



  /* ==========================================================
     HEADER CART BUTTON -> ESSENTIAL CART DRAWER
     Only the ToonFetti header button [data-cart-open] is handled.
     Native /cart is the safe fallback if the app is unavailable.
     ========================================================== */

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    const cartButton = event.target.closest('[data-cart-open]');
    if (!cartButton) return;

    event.preventDefault();

    const essentialCart = window.essentialCartApi;
    if (essentialCart && typeof essentialCart.openCart === 'function') {
      essentialCart.openCart();
    } else {
      window.location.assign(shopRoot() + 'cart');
    }
  });

  /* ==========================================================

     MOBILE MENU

     ========================================================== */



  const mobileMenu =

    qs('[data-mobile-menu]');



  const mobileOpen =

    qs('[data-mobile-open]');



  const mobileClose =

    qs('[data-mobile-close]');



  function openMobile() {

    if (!mobileMenu) {

      return;

    }



    mobileMenu.hidden =

      false;



    if (mobileOpen) {

      mobileOpen.setAttribute(

        'aria-expanded',

        'true'

      );

    }



    document.body.style.overflow =

      'hidden';

  }



  function closeMobile() {

    if (!mobileMenu) {

      return;

    }



    mobileMenu.hidden =

      true;



    if (mobileOpen) {

      mobileOpen.setAttribute(

        'aria-expanded',

        'false'

      );

    }



    document.body.style.overflow =

      '';

  }



  if (mobileOpen) {

    mobileOpen.addEventListener(

      'click',

      openMobile

    );

  }



  if (mobileClose) {

    mobileClose.addEventListener(

      'click',

      closeMobile

    );

  }



  if (mobileMenu) {

    mobileMenu.addEventListener(

      'click',

      function (event) {

        if (

          event.target ===

          mobileMenu

        ) {

          closeMobile();

        }

      }

    );

  }



  /* ==========================================================

     HEADER DROPDOWNS

     Supports Shop + Resources independently.

     ========================================================== */



  const navDropdowns =

    qsa('[data-nav-dropdown]');



  function closeDropdown(dropdown) {

    if (!dropdown) {

      return;

    }



    dropdown.classList.remove(

      'is-open'

    );



    const button =

      qs(

        '.tf-nav-dropbtn',

        dropdown

      );



    if (button) {

      button.setAttribute(

        'aria-expanded',

        'false'

      );

    }

  }



  function closeAllDropdowns(

    exceptDropdown = null

  ) {

    navDropdowns.forEach(

      function (dropdown) {

        if (

          exceptDropdown &&

          dropdown === exceptDropdown

        ) {

          return;

        }



        closeDropdown(

          dropdown

        );

      }

    );

  }



  navDropdowns.forEach(

    function (dropdown) {

      const button =

        qs(

          '.tf-nav-dropbtn',

          dropdown

        );



      if (!button) {

        return;

      }



      button.addEventListener(

        'click',

        function (event) {

          event.preventDefault();



          const willOpen =

            !dropdown.classList.contains(

              'is-open'

            );



          closeAllDropdowns(

            dropdown

          );



          dropdown.classList.toggle(

            'is-open',

            willOpen

          );



          button.setAttribute(

            'aria-expanded',

            willOpen

              ? 'true'

              : 'false'

          );

        }

      );

    }

  );



  document.addEventListener(

    'click',

    function (event) {

      if (!(event.target instanceof Node)) {

        return;

      }



      const clickedInsideDropdown =

        navDropdowns.some(

          function (dropdown) {

            return dropdown.contains(

              event.target

            );

          }

        );



      if (!clickedInsideDropdown) {

        closeAllDropdowns();

      }

    }

  );



  /* ==========================================================

     SUPPORT DRAWER

     ========================================================== */



  const supportDrawer =

    qs('[data-support-drawer]');



  const supportBackdrop =

    qs('[data-support-backdrop]');



  const supportOpen =

    qs('[data-support-open]');



  const supportClose =

    qs('[data-support-close]');



  function openSupport() {

    if (!supportDrawer) {

      return;

    }



    supportDrawer.classList.add(

      'is-open'

    );



    supportDrawer.setAttribute(

      'aria-hidden',

      'false'

    );



    if (supportOpen) {

      supportOpen.setAttribute(

        'aria-expanded',

        'true'

      );

    }



    if (supportBackdrop) {

      supportBackdrop.hidden =

        false;

    }



    document.body.style.overflow =

      'hidden';

  }



  function closeSupport() {

    if (!supportDrawer) {

      return;

    }



    supportDrawer.classList.remove(

      'is-open'

    );



    supportDrawer.setAttribute(

      'aria-hidden',

      'true'

    );



    if (supportOpen) {

      supportOpen.setAttribute(

        'aria-expanded',

        'false'

      );

    }



    if (supportBackdrop) {

      supportBackdrop.hidden =

        true;

    }



    document.body.style.overflow =

      '';

  }



  if (supportOpen) {

    supportOpen.addEventListener(

      'click',

      function (event) {

        event.preventDefault();

        openSupport();

      }

    );

  }



  if (supportClose) {

    supportClose.addEventListener(

      'click',

      closeSupport

    );

  }



  if (supportBackdrop) {

    supportBackdrop.addEventListener(

      'click',

      closeSupport

    );

  }



  /* ==========================================================

     VIDEO INITIALIZATION

     Only visible videos play.

     ========================================================== */



  let tfVideoObserver = null;



  function getTfVideoObserver() {

    if (tfVideoObserver) {

      return tfVideoObserver;

    }



    if (

      !(

        'IntersectionObserver'

        in window

      )

    ) {

      return null;

    }



    tfVideoObserver =

      new IntersectionObserver(

        function (entries) {

          entries.forEach(

            function (entry) {

              const video =

                entry.target;



              if (!video) {

                return;

              }



              if (

                entry.isIntersecting &&

                entry.intersectionRatio >= 0.25

              ) {

                video

                  .play()

                  .catch(

                    function () {}

                  );

              } else {

                video.pause();

              }

            }

          );

        },

        {

          rootMargin:

            '100px 0px 100px 0px',

          threshold:

            [0, 0.25, 0.75]

        }

      );



    return tfVideoObserver;

  }



  function initializeVideos(

    root = document

  ) {

    root

      .querySelectorAll(

        [

          '.tf-hero-media video',

          '.tf-content-hero-media video',

          '.tf-collection-hero-image video',

          '.tf-mini-media video',

          '.tf-mini-worlds-video video'

        ].join(',')

      )

      .forEach(

        function (video) {

          video.muted =

            true;



          video.defaultMuted =

            true;



          video.setAttribute(

            'muted',

            ''

          );



          /*

           * Off-screen videos should not compete

           * with page navigation.

           */

          video.preload =

            'metadata';



          const wrapper =

            video.parentElement;



          const button =

            wrapper

              ? wrapper.querySelector(

                  '[data-video-toggle], [data-mini-video-toggle]'

                )

              : null;



          const reducedMotion =

            window.matchMedia &&

            window.matchMedia(

              '(prefers-reduced-motion: reduce)'

            ).matches;



          if (reducedMotion) {

            video.pause();



            if (button) {

              button.textContent =

                '▶';



              button.setAttribute(

                'aria-label',

                'Play video'

              );

            }



            return;

          }



          if (

            video.dataset

              .tfViewportVideoReady ===

            'true'

          ) {

            return;

          }



          video.dataset

            .tfViewportVideoReady =

            'true';



          const observer =

            getTfVideoObserver();



          if (observer) {

            observer.observe(

              video

            );

          } else {

            /*

             * Conservative fallback:

             * do not autoplay every video.

             */

            video.pause();

          }

        }

      );

  }



  /* ==========================================================

     VIDEO CONTROLS

     ========================================================== */



  document.addEventListener(

    'click',

    function (event) {

      if (!(event.target instanceof Element)) {

        return;

      }



      const button =

        event.target.closest(

          '[data-video-toggle], [data-mini-video-toggle]'

        );



      if (!button) {

        return;

      }



      const wrapper =

        button.parentElement;



      const video =

        wrapper

          ? wrapper.querySelector(

              'video'

            )

          : null;



      if (!video) {

        return;

      }



      event.preventDefault();



      if (video.paused) {

        video

          .play()

          .catch(

            function () {}

          );



        button.textContent =

          'Ⅱ';



        button.setAttribute(

          'aria-label',

          'Pause video'

        );

      } else {

        video.pause();



        button.textContent =

          '▶';



        button.setAttribute(

          'aria-label',

          'Play video'

        );

      }

    }

  );



  /* ==========================================================

     ESCAPE KEY

     ========================================================== */



  document.addEventListener(

    'keydown',

    function (event) {

      if (

        event.key !==

        'Escape'

      ) {

        return;

      }



      closeMobile();

      closeSupport();

      closeAllDropdowns();

    }

  );



  /* ==========================================================

     ADD-TO-CART CELEBRATION STYLES

     ========================================================== */



  function installAddCelebrationStyles() {

    if (

      document.getElementById(

        'TfAddCelebrationStyles'

      )

    ) {

      return;

    }



    const style =

      document.createElement('style');



    style.id =

      'TfAddCelebrationStyles';



    style.textContent = `

      .tf-add-celebration{

        position:fixed;

        left:50%;

        bottom:26px;

        z-index:99999;

        display:flex;

        align-items:center;

        gap:12px;

        min-width:280px;

        max-width:min(420px,calc(100vw - 28px));

        padding:12px 16px 12px 12px;

        box-sizing:border-box;

        border:1px solid rgba(36,36,36,.10);

        border-radius:18px;

        background:#FFF9F1;

        box-shadow:0 18px 50px rgba(36,36,36,.18);

        color:#242424;

        opacity:0;

        transform:translate(-50%,14px) scale(.98);

        transition:opacity .22s ease,transform .22s ease;

        pointer-events:none;

      }



      .tf-add-celebration.is-visible{

        opacity:1;

        transform:translate(-50%,0) scale(1);

      }



      .tf-add-celebration__character{

        display:flex;

        align-items:center;

        justify-content:center;

        width:58px;

        min-width:58px;

        max-width:58px;

        line-height:0;

      }



      .tf-add-celebration__character img{

        display:block;

        width:58px;

        max-width:58px;

        height:auto;

        object-fit:contain;

      }



      .tf-add-celebration__copy{

        min-width:0;

        display:flex;

        flex-direction:column;

        align-items:flex-start;

        gap:2px;

      }



      .tf-add-celebration__eyebrow{

        color:#B92431;

        font-size:7px;

        line-height:1;

        font-weight:900;

        letter-spacing:.09em;

        text-transform:uppercase;

      }



      .tf-add-celebration__copy strong{

        color:#242424;

        font-size:13px;

        line-height:1.2;

        font-weight:900;

      }



      .tf-add-celebration__copy small{

        max-width:280px;

        overflow:hidden;

        color:#6F6B67;

        font-size:8px;

        line-height:1.25;

        font-weight:700;

        text-overflow:ellipsis;

        white-space:nowrap;

      }



      @media(max-width:749px){

        .tf-add-celebration{

          bottom:16px;

          min-width:0;

          width:calc(100vw - 24px);

          max-width:420px;

        }



        .tf-add-celebration__character{

          width:50px;

          min-width:50px;

          max-width:50px;

        }



        .tf-add-celebration__character img{

          width:50px;

          max-width:50px;

        }

      }



      @media(prefers-reduced-motion:reduce){

        .tf-add-celebration{

          transition:none;

          transform:translate(-50%,0);

        }



        .tf-add-celebration.is-visible{

          transform:translate(-50%,0);

        }

      }

    `;



    document.head.appendChild(

      style

    );

  }



  /* ==========================================================

     INITIALIZATION

     ========================================================== */



  function initialize() {

    installAddCelebrationStyles();



    /*

     * Do NOT request /cart.js on every page load.

     * Header cart count is already rendered by Liquid.

     */

    initializeVideos();

    initializeAddCelebration();

  }



  if (

    document.readyState ===

    'loading'

  ) {

    document.addEventListener(

      'DOMContentLoaded',

      initialize,

      {

        once: true

      }

    );

  } else {

    initialize();

  }



  /* ==========================================================

     SHOPIFY THEME EDITOR SUPPORT

     ========================================================== */



  document.addEventListener(

    'shopify:section:load',

    function (event) {

      initializeVideos(

        event.target

      );

    }

  );



  /* ==========================================================

     NAVIGATION CLEANUP

     Does not intercept navigation.

     ========================================================== */



  window.addEventListener(

    'pagehide',

    function () {

      qsa('video')

        .forEach(

          function (video) {

            try {

              video.pause();

            } catch (error) {}

          }

        );



      document.body.style.overflow =

        '';

    }

  );

})();